import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import AuthCallback from './components/AuthCallback';
import PortalCallback from './components/PortalCallback';
import Home from './pages/Home';
import About from './pages/About';
import Team from './pages/Team';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import Careers from './pages/Careers';
import Directory from './pages/Directory';
import Login from './pages/Login';
import PortalLogin from './pages/PortalLogin';
import PortalLoginCustom from './pages/PortalLoginCustom';
import PortalDashboard from './pages/PortalDashboard';
import EmployeeFiles from './pages/EmployeeFiles';
import TrainSchedule from './pages/TrainSchedule';
import Services from './pages/Services';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function AppRouter() {
  const location = useLocation();
  const isPortalPage = location.pathname.startsWith('/portal');
  
  // CRITICAL: Check for session_id in URL hash BEFORE routing
  // This must be synchronous (not in useEffect) to prevent race conditions
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <>
      {!isPortalPage && <Navigation />}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/portal/login" element={<PortalLoginCustom />} />
        <Route path="/portal/dashboard" element={<PortalDashboard />} />
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/team" element={<Team />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/schedule" element={<TrainSchedule />} />
        <Route path="/services" element={<Services />} />
        <Route path="/directory" element={<Directory />} />
        <Route path="/employee-files" element={<EmployeeFiles />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      {!isPortalPage && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
